import React, { useRef } from 'react';

// Cursor-tracked glow (à la reactbits' SpotlightCard) — a soft radial highlight
// that follows the mouse, plus an optional subtle 3D tilt.
export function SpotlightCard({
  children,
  className = '',
  style = {},
  spotlightColor = '#0056D2',
  tilt = false,
  ...props
}) {
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    el.style.setProperty('--spot-x', `${x}px`);
    el.style.setProperty('--spot-y', `${y}px`);

    if (tilt) {
      const rx = ((y / rect.height) - 0.5) * -5;
      const ry = ((x / rect.width) - 0.5) * 5;
      el.style.setProperty('--tilt-x', `${rx}deg`);
      el.style.setProperty('--tilt-y', `${ry}deg`);
    }
  };

  const handleMouseLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty('--tilt-x', '0deg');
    el.style.setProperty('--tilt-y', '0deg');
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={`spotlight-card ${className}`}
      style={{ '--spot-color': spotlightColor, ...style }}
      {...props}
    >
      <div className="spotlight-card-glow" />
      <div className="spotlight-card-content">{children}</div>
    </div>
  );
}
